var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import { CLASS } from './_tableConsts';
let SdsTableBase = (() => {
    var _a, _SdsTableBase_freezeFirstColumn_accessor_storage;
    let _classSuper = LitElement;
    let _freezeFirstColumn_decorators;
    let _freezeFirstColumn_initializers = [];
    let _freezeFirstColumn_extraInitializers = [];
    return _a = class SdsTableBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsTableBase_freezeFirstColumn_accessor_storage.set(this, __runInitializers(this, _freezeFirstColumn_initializers, false));
                this.onScrollHandler = (__runInitializers(this, _freezeFirstColumn_extraInitializers), (e) => this.onScroll(e));
            }
            /**
             * True if first column of this table is frozen,
             * so that if scroll is needed first column does not scroll.
             * @attr
             */
            get freezeFirstColumn() { return __classPrivateFieldGet(this, _SdsTableBase_freezeFirstColumn_accessor_storage, "f"); }
            set freezeFirstColumn(value) { __classPrivateFieldSet(this, _SdsTableBase_freezeFirstColumn_accessor_storage, value, "f"); }
            willUpdate(changedProperties) {
                if (changedProperties.has('freezeFirstColumn')) {
                    if (this.freezeFirstColumn) {
                        this.addModifierClass(CLASS.FROZEN);
                    }
                    else if (!this.freezeFirstColumn) {
                        this.removeModifierClass(CLASS.FROZEN);
                    }
                }
            }
            async firstUpdated() {
                await this.updateComplete;
                this.addGlobalStyle();
                this.addEvents();
                this.classList.add(this.getCustomClass());
            }
            disconnectedCallback() {
                this.removeEvents();
            }
            getPaginator() {
                const paginator = this.querySelector('sds-paginator');
                if (!isNil(paginator)) {
                    return paginator;
                }
                else {
                    return undefined;
                }
            }
            addEvents() {
                this.addEventListener('scroll', this.onScrollHandler);
            }
            removeEvents() {
                this.removeEventListener('scroll', this.onScrollHandler);
            }
            addGlobalStyle() {
                appendStylesToTheStyleRoot(this, this.getCustomClass(), this.getCssText());
            }
            addModifierClass(modifier) {
                this.classList.add(`${this.getCustomClass()}--${modifier}`);
            }
            removeModifierClass(modifier) {
                this.classList.remove(`${this.getCustomClass()}--${modifier}`);
            }
            detectScroll() {
                if (this.scrollWidth > this.clientWidth) {
                    this.addModifierClass(CLASS.HAS_SCROLL);
                }
            }
            onScroll(event) {
                const scroll = event.target.scrollLeft;
                const scrollSpace = this.scrollWidth - this.clientWidth;
                scroll > 0
                    ? this.addModifierClass(CLASS.SCROLLED)
                    : this.removeModifierClass(CLASS.SCROLLED);
                scroll === scrollSpace
                    ? this.addModifierClass(CLASS.SCROLL_END)
                    : this.removeModifierClass(CLASS.SCROLL_END);
            }
        },
        _SdsTableBase_freezeFirstColumn_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _freezeFirstColumn_decorators = [property({ type: Boolean, attribute: 'freeze-first-column' })];
            __esDecorate(_a, null, _freezeFirstColumn_decorators, { kind: "accessor", name: "freezeFirstColumn", static: false, private: false, access: { has: obj => "freezeFirstColumn" in obj, get: obj => obj.freezeFirstColumn, set: (obj, value) => { obj.freezeFirstColumn = value; } }, metadata: _metadata }, _freezeFirstColumn_initializers, _freezeFirstColumn_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsTableBase };
